export default __webpack_public_path__ + "static/media/bb5.1.9a8d6bc7.png";